import { WorkflowRole } from '@exam-management/common/types';
import { WorkflowStepCode } from '@exam-management/graphql';

enum Ability {
  VIEW = 'VIEW',
  CREATE = 'CREATE',
  EDIT = 'EDIT',
  ADD_ASSIGNEE = 'ADD_ASSIGNEE',
}

enum TaskType {
  TASK = 'TASK',
  SUBTASK = 'SUBTASK',
}

interface GetQSetReviewTaskAbilityParams {
  workflowRoles: WorkflowRole[];
  status: WorkflowStepCode;
  ability: (keyof typeof Ability)[];
  taskType: (keyof typeof TaskType)[];
}

export default function getQSetReviewTaskAbility({
  workflowRoles,
  status,
  ability,
  taskType,
}: GetQSetReviewTaskAbilityParams) {
  const isTaskOwner = workflowRoles.includes(WorkflowRole.TASK_OWNER);
  const isTaskAssignee = workflowRoles.includes(WorkflowRole.TASK_ASSIGNEE);
  const isTodo = status === WorkflowStepCode.ReviewQsetTodo;
  const isInReview = status === WorkflowStepCode.ReviewQsetInReview;
  const isReviewed = status === WorkflowStepCode.ReviewQsetReviewed;

  const abilityMap: Record<TaskType, Record<Ability, boolean>> = {
    [TaskType.TASK]: {
      [Ability.CREATE]: false,
      [Ability.EDIT]: isTaskOwner && isTodo,
      [Ability.VIEW]: true,
      [Ability.ADD_ASSIGNEE]:
        (isTaskAssignee && (isTodo || isInReview || isReviewed)) ||
        (isTaskOwner && (isTodo || isInReview || isReviewed)),
    },
    [TaskType.SUBTASK]: {
      [Ability.CREATE]: isTaskAssignee && (isTodo || isInReview || isReviewed),
      [Ability.EDIT]: isTaskAssignee && (isTodo || isInReview || isReviewed),
      [Ability.VIEW]: true,
      [Ability.ADD_ASSIGNEE]: false,
    },
  };

  return taskType.some((task) => ability.some((ability) => abilityMap[task][ability]));
}
